<script setup lang="ts">
import { usePageStore } from '@voix/store/pageStore'
import type { VoixCheckboxFieldInterface } from '@voix/types'

const props = defineProps<{
  fields: {
    beachFrontAccess: VoixCheckboxFieldInterface
    oceanFrontLocation: VoixCheckboxFieldInterface
  }
}>()

defineSlice({
  description: 'Hard-coded Always included',
  name: {
    label: 'Always Included',
    group: 'Always Included',
    layouts: ['Wyndham', 'WyndhamCancun', 'WyndhamPlaya'],
  },
  tags: ['Info'],
  templates: [{ label: 'Always Included', fields: [] }],
  fields: {
    beachFrontAccess: {
      type: 'checkbox',
      label: 'Beachfront Access',
      default: true,
    },
    oceanFrontLocation: {
      type: 'checkbox',
      label: 'Oceanfront Location',
      default: false,
    },
  },
})

const currentResort = inject<any>('currentResort')

const showCamp = computed(() => {
  return false
})
const currentPage = computed(() => {
  const pageStore = usePageStore()
  return pageStore.currentPage
})
</script>

<template>
  <div
    class="flex justify-center"
  >
    <div class="py-8 md:p-12 container text-center flex flex-col items-center">
      <h4 class="mb-8">
        <span
          v-if="currentPage?.language_code === 'en'"
          class="sans-serif"
        >All Yours &amp; Always Included</span>
        <span
          v-if="currentPage?.language_code === 'es'"
          class="sans-serif"
        >Todo Tuyo y Siempre Incluido</span>
      </h4>
      <ul class="grid grid-cols-1 md:grid-cols-3 w-full">
        <li
          v-if="fields.beachFrontAccess.value"
          class="w-full p-4 flex items-center justify-center text-left"
        >
          <IconsWyndhamIcons
            icon="sun"
            class="h-8 mr-4"
          />
          <div>
            <h6 v-if="currentPage?.language_code === 'en'">
              Beachfront Access
            </h6>
            <h6 v-if="currentPage?.language_code === 'es'">
              Acceso directo a la playa
            </h6>
          </div>
        </li>
        <li
          v-if="fields.oceanFrontLocation.value"
          class="w-full p-4 flex items-center justify-center text-left"
        >
          <IconsWyndhamIcons
            icon="sun"
            class="h-8 mr-4"
          />
          <div>
            <h6 v-if="currentPage?.language_code === 'en'">
              Oceanfront Location
            </h6>
            <h6 v-if="currentPage?.language_code === 'es'">
              Oceanfront Location
            </h6>
          </div>
        </li>
        <li class="w-full p-4 flex items-center justify-center text-left">
          <IconsWyndhamIcons
            icon="heart"
            class="h-8 mr-4"
          />
          <div>
            <h6 v-if="currentPage?.language_code === 'en'">
              Contemporary Accommodations
            </h6>
            <h6 v-if="currentPage?.language_code === 'es'">
              Habitaciones modernas
            </h6>
          </div>
        </li>
        <li class="w-full p-4 flex items-center justify-center text-left">
          <IconsWyndhamIcons
            icon="surf"
            class="h-8 mr-4"
          />
          <div>
            <h6 v-if="currentPage?.language_code === 'en'">
              Outdoor Activities
            </h6>
            <h6 v-if="currentPage?.language_code === 'es'">
              Aventuras Al Aire Libre
            </h6>
          </div>
        </li>
        <li class="w-full p-4 flex items-center justify-center text-left">
          <IconsWyndhamIcons
            icon="pool"
            class="h-8 mr-4"
          />
          <div>
            <h6 v-if="currentPage?.language_code === 'en'">
              Pristine Pools
            </h6>
            <h6 v-if="currentPage?.language_code === 'es'">
              Piscinas refrescantes
            </h6>
          </div>
        </li>
        <li class="w-full p-4 flex items-center justify-center text-left">
          <IconsWyndhamIcons
            icon="star"
            class="h-8 mr-4"
          />
          <div>
            <h6 v-if="currentPage?.language_code === 'en'">
              Live Entertainment
            </h6>
            <h6 v-if="currentPage?.language_code === 'es'">
              Entretenimiento en vivo
            </h6>
          </div>
        </li>
        <li class="w-full p-4 flex items-center justify-center text-left">
          <IconsWyndhamIcons
            icon="food"
            class="h-8 mr-4"
          />
          <div>
            <h6 v-if="currentPage?.language_code === 'en'">
              Dining &amp; Drinks
            </h6>
            <h6 v-if="currentPage?.language_code === 'es'">
              Bebidas y comidas
            </h6>
          </div>
        </li>
        <li class="w-full p-4 flex items-center justify-center text-left">
          <IconsWyndhamIcons
            icon="drink"
            class="h-8 mr-4"
          />
          <div>
            <h6 v-if="currentPage?.language_code === 'en'">
              Infinite Libations
            </h6>
            <h6 v-if="currentPage?.language_code === 'es'">
              Bebidas Sin Fin
            </h6>
          </div>
        </li>
        <li class="w-full p-4 flex items-center justify-center text-left">
          <IconsWyndhamIcons
            icon="wifi"
            class="h-8 mr-4"
          />
          <div>
            <h6 v-if="currentPage?.language_code === 'en'">
              Unlimited WI-FI
            </h6>
            <h6 v-if="currentPage?.language_code === 'es'">
              WI-FI Ilimitado
            </h6>
          </div>
        </li>
        <li
          v-if="showCamp"
          class="w-full p-4 flex items-center justify-center text-left"
        >
          <IconsWyndhamIcons
            icon="fire"
            class="h-8 mr-4"
          />
          <div>
            <h6 v-if="currentPage?.language_code === 'en'">
              Camp Alltra
            </h6>
            <h6 v-if="currentPage?.language_code === 'es'">
              Camp Alltra
            </h6>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
